import { Outlet } from 'react-router'

import { ProjectBreadcrumbs } from '@/components/breadcrumbs'
import { Header } from '@/components/header'
import { Sidebar } from '@/components/sidebar'
import { TooltipProvider } from '@/components/ui/tooltip'
import { useQueryParams } from '@/hooks/use-query-params'

import { useMenuItems } from './menu-items'

export function ProjectLayout() {
  const { getQueryParams } = useQueryParams()

  const { companyId } = getQueryParams()

  const backLink = `/companies/${companyId}/projects`

  const menuItems = useMenuItems()

  return (
    <div className="relative flex h-screen flex-col bg-studio-image bg-cover bg-center bg-no-repeat antialiased">
      <TooltipProvider>
        <Header backLink={backLink}>
          <Header.Breadcrumbs>
            <ProjectBreadcrumbs />
          </Header.Breadcrumbs>
        </Header>

        <div className="flex min-h-0 flex-1">
          <Sidebar menuItems={menuItems} theme="dark" />

          <main className="h-full w-full select-none overflow-hidden p-4">
            <Outlet />
          </main>
        </div>
      </TooltipProvider>
    </div>
  )
}
